import { Flex, Typography } from "antd";
import { useState } from "react";
import moment from "moment";
import OrderMenu from "./OrderMenu";
import DashboardMenu from "../dashboard/DashboardMenu";
import ExportPage from "../../utils/ExportPage";

const { Text } = Typography;

const OrderHeader: React.FC<any> = ({
  setFilters,
  sizes,
  deliveryMethods,
  deliveryStatus,
  templates,
  filters,
  onExport,
}) => {
  const defaultEnd = moment();
  const defaultStart = moment().startOf("month");
  const [dateResetKey, setDateResetKey] = useState(0);
  const [dates, setDates] = useState<[string[] | null, string] | null>([
    [defaultStart.format("MM/DD/YYYY"), defaultEnd.format("MM/DD/YYYY")],
    "mtd",
  ]);

  const resetDates = () => {
    const defaultDates: [string[], string] = [
      [defaultStart.format("MM/DD/YYYY"), defaultEnd.format("MM/DD/YYYY")],
      "mtd",
    ];
    setDates(defaultDates);
    setDateResetKey((k) => k + 1);
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          marginBottom: '16px'
        }}
      >
        <div style={{ width: "60%", textAlign: "left" }}>
          <Flex align="center" gap={16} style={{ padding: "0px" }}>
            <Text strong={true} style={{ margin: 0, fontWeight: 400, fontSize: 20 }}>
              Order List
            </Text>
            <DashboardMenu key={dateResetKey} setFilters={setDates} />
            {dates?.[0]?.length && (
              <Text>{`${dates[0][0]}-${dates[0][1]}`}</Text>
            )}
          </Flex>
        </div>
        <div style={{ width: "40%", textAlign: "right" }}>
          <ExportPage
            onExport={onExport}
          />
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          height: "40px",
          alignItems: "center",
          marginBottom: '16px'
        }}
      >
        <div style={{ width: "100%", textAlign: "left" }}>
          <OrderMenu
            sizes={sizes}
            deliveryMethods={deliveryMethods}
            deliveryStatus={deliveryStatus}
            templates={templates}
            setFilters={setFilters}
            filters={filters}
            dates={dates}
            resetDates={resetDates}
          />
        </div>
      </div>
    </>
  );
};

export default OrderHeader;
